import request from '@/utils/request'; // 复用项目统一的 axios 实例
export default {
    getList() {
            return request({
                url: '/institutions/',
                method: 'get',
            });
        },
}